import {
  useSessionStore,
} from "~/stores/session";
import {
  getAuthenticatedLandingRoute,
} from "~/utils/auth-navigation";

export default defineNuxtRouteMiddleware(async () => {
  if (import.meta.server) {
    return;
  }

  const sessionStore = useSessionStore();

  // Wait for session to be ready
  if (!sessionStore.ready) {
    await sessionStore.initialize();
  }

  // If already authenticated on login page, redirect to home
  if (sessionStore.isAuthenticated) {
    return navigateTo(getAuthenticatedLandingRoute(sessionStore.userRoles));
  }
});
